import { Redirect, Switch } from 'react-router-dom';

import { lazyWithChunkRecovery } from 'helper/lazyWithChunkRecovery';
import { PublicLayout } from 'layouts';
import { PublicRoute, UnauthorizedOnlyRoute, MfaRoute, PrivateRoute } from 'components/routes';

import * as routes from './routes';

const AuthenticationSetup = lazyWithChunkRecovery(() => import('screens/Auth/AuthenticationSetup'));
const SetNewPassword = lazyWithChunkRecovery(() => import('screens/Auth/SetNewPassword'));
const Login = lazyWithChunkRecovery(() => import('screens/Auth/Login'));
const LoginMfa = lazyWithChunkRecovery(() => import('screens/Auth/LoginMfa'));
const LoginSSO = lazyWithChunkRecovery(() => import('screens/Auth/LoginSSO'));
const Registration = lazyWithChunkRecovery(() => import('screens/Auth/Registration'));
const NomineeReject = lazyWithChunkRecovery(() => import('screens/NomineeReject'));
const CulturalProjectProcess = lazyWithChunkRecovery(() => import('screens/CulturalProjectProcess'));
const Invitation = lazyWithChunkRecovery(() => import('screens/Invitation'));
const PrivacyPolicy = lazyWithChunkRecovery(() => import('screens/PrivacyPolicy'));
const NomineeReport = lazyWithChunkRecovery(() => import('screens/NomineeReport'));
const FeedbackProcess = lazyWithChunkRecovery(() => import('screens/FeedbackProcess'));

const PublicRoutes = () => {
  return (
    <PublicLayout>
      <Switch>
        <PublicRoute exact path={`${routes.invitation}/:invitationId`} component={Invitation} />
        <PublicRoute exact path={routes.privacyPolicy} component={PrivacyPolicy} />
        <UnauthorizedOnlyRoute exact path={`${routes.loginScreen}/:invitationId?`} component={Login} />
        <UnauthorizedOnlyRoute exact path={`${routes.loginSSOScreen}`} component={LoginSSO} />
        <UnauthorizedOnlyRoute exact path={`${routes.registrationScreen}/:invitationId`} component={Registration} />
        <UnauthorizedOnlyRoute exact path={`${routes.setNewPassword}/:uid/:token`} component={SetNewPassword} />
        <MfaRoute exact path={routes.authenticationSetup} component={AuthenticationSetup} />
        <MfaRoute exact path={routes.loginMfa} component={LoginMfa} />
        <PublicRoute
          exact
          path={`${routes.publicCulturalProjectProcess}/:projectId`}
          component={CulturalProjectProcess}
        />
        <PrivateRoute
          exact
          path={`${routes.culturalProjectProcess}/:projectId/:userId?`}
          component={CulturalProjectProcess}
        />
        <PublicRoute exact path={`${routes.nomineeReject}/:id`} component={NomineeReject} />
        <PublicRoute exact path={`${routes.nomineeReport}/:id`} component={NomineeReport} />
        <PublicRoute exact path={`${routes.feedbackProcess}/:nominee`} component={FeedbackProcess} />{' '}
        <Redirect from="*" to={routes.home} />
      </Switch>
    </PublicLayout>
  );
};

export default PublicRoutes;
